import { defineStore } from 'pinia';
import { ref, onMounted, onUnmounted } from 'vue';

export const useKeyboardStore = defineStore('keyboard', () => {
    const shortcuts = ref(new Map());

    function register(shortcut, callback) {
        shortcuts.value.set(shortcut, callback);
    }

    function unregister(shortcut) {
        shortcuts.value.delete(shortcut);
    }

    function handleKeyEvent(event) {
        if (!event.key) return false;

        const shortcutParts = [];
        if (event.ctrlKey) shortcutParts.push('Ctrl');
        if (event.altKey) shortcutParts.push('Alt');
        if (event.shiftKey) shortcutParts.push('Shift');

        shortcutParts.push(event.key.toUpperCase());
        const shortcutString = shortcutParts.join('+');
        
        if (shortcuts.value.has(shortcutString)) {
            event.preventDefault();
            event.stopPropagation();
            const callback = shortcuts.value.get(shortcutString);
            if (callback) callback(event);
            return true;
        }
        return false;
    }

    const keydownListener = (event) => {
        handleKeyEvent(event);
    };

    onMounted(() => {
        window.addEventListener('keydown', keydownListener);
    });

    onUnmounted(() => {
        window.removeEventListener('keydown', keydownListener);
    });

    return {
        shortcuts,
        register,
        unregister,
        handleKeyEvent
    };
});